<nav mat-tab-nav-bar>
    <a mat-tab-link [routerLink]="['gesamt']" routerLinkActive #tala="routerLinkActive" [active]="tala.isActive"
        >Gesamt</a
    >
    <a
        mat-tab-link
        [routerLink]="['gruppe']"
        routerLinkActive
        #tierarztGruppe="routerLinkActive"
        [active]="tierarztGruppe.isActive"
        >Tierarzt Gruppe</a
    >
    <a
        mat-tab-link
        [routerLink]="['einzel']"
        routerLinkActive
        #tierarztEinzel="routerLinkActive"
        [active]="tierarztEinzel.isActive"
        >Tierarzt Einzel</a
    >
</nav>
<router-outlet></router-outlet>
